"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigninClickFailEvent = exports.SigninHomeSuccessEvent = exports.SigninClickSuccessEvent = exports.SigninLandingSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class SigninLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SIGNIN_LANDING_SUCCESS';
    }
}
exports.SigninLandingSuccessEvent = SigninLandingSuccessEvent;
class SigninClickSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SIGNIN_CLICK_SUCCESS';
    }
}
exports.SigninClickSuccessEvent = SigninClickSuccessEvent;
class SigninHomeSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SIGNIN_HOME_SUCCESS';
    }
}
exports.SigninHomeSuccessEvent = SigninHomeSuccessEvent;
class SigninClickFailEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'SIGNIN_CLICK_FAILED';
    }
}
exports.SigninClickFailEvent = SigninClickFailEvent;
//# sourceMappingURL=signin.events.js.map